// extracted by mini-css-extract-plugin
export var active = "_26-d";
export var blink = "_26-e";
export var container = "_26-5";
export var controls = "_26-0";
export var controlsRight = "_26-1";
export var fakeCursor = "_26-c";
export var hidden = "_26-b";
export var quillContainerSmall = "_26-7";
export var quillEditor = "_26-6";
export var quillEditorSmall = "_26-8";
export var quillFormatButtons = "_26-a";
export var quillToolbar = "_26-9";
export var removePadding = "_26-2";
export var state = "_26-3";
export var stateTitle = "_26-4";